import { render, staticRenderFns } from "./VisualizacionSeguidoresIndustria.vue?vue&type=template&id=42e5f40a&scoped=true&"
import script from "./VisualizacionSeguidoresIndustria.vue?vue&type=script&lang=js&"
export * from "./VisualizacionSeguidoresIndustria.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionSeguidoresIndustria.vue?vue&type=style&index=0&id=42e5f40a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5f40a",
  null
  
)

export default component.exports